const keys = {
    firebase: {
        apiKey: "AIzaSyBnbZHthRZnKRcFoxwOYy_X1x0Kdf_MnHc",
        authDomain: "blogit-f6c55.firebaseapp.com",
        databaseURL: "https://blogit-f6c55.firebaseio.com",
        projectId: "blogit-f6c55",
        storageBucket: "blogit-f6c55.appspot.com",
        messagingSenderId: "730907974847"
    }
};

export default keys;